module.exports = "/assets/data/a19aa10883f9c0835d07a979849c047a-TS12.data.json";